import moment from "moment";
import _ from "lodash";
import EXIF from "exif-js";
import inside from "point-in-polygon";

function getBoundary(map, city) {
  var bdary = new AMap.Boundary();
  bdary.get(city, function(rs) {
    //for循环都删除掉了，只剩下这个
    //网上查了下，东西经南北纬的范围
    var EN_JW = "180, 90;"; //东北角
    var NW_JW = "-180,  90;"; //西北角
    var WS_JW = "-180, -90;"; //西南角
    var SE_JW = "180, -90;"; //东南角
    //4.添加环形遮罩层
    var ply1 = new AMap.Polygon(
      rs.boundaries[0] + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW,
      {
        strokeColor: "none",
        fillColor: "#081734",
        fillOpacity: 1,
        strokeOpacity: 0.5
      }
    ); //建立多边形覆盖物

    map.addOverlay(ply1);
    //5. 给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
    var ply = new AMap.Polygon(rs.boundaries[0], {
      strokeWeight: 2,
      strokeColor: "#00f",
      fillColor: ""
    });
    map.addOverlay(ply);
    // map.setViewport(ply.getPath());    //调整视野
  });
}

function drawBoundary(map, city, color) {
  var bdary = new AMap.Boundary();
  var color = color ? color : "rgba(255,255,255,0.9)";
  bdary.get(city, function(rs) {
    //获取行政区域
    console.log(rs);
    var count = rs.boundaries.length; //行政区域的点有多少个
    if (count === 0) {
      console.log("未能获取当前输入行政区域");
      return;
    }
    var pointArray = [];
    for (var i = 0; i < count; i++) {
      var ply = new AMap.Polygon(rs.boundaries[i], {
        strokeWeight: 2,
        strokeColor: color,
        fillColor: ""
      }); //建立多边形覆盖物
      map.addOverlay(ply); //添加覆盖物
    }
  });
}

function drwaNovaecsBoundary(map, data, color) {
  let colors = color ? color : "rgba(255,155,155,0.9)";
  //获取行政区域
  var count = data.length; //行政区域的点有多少个
  if (count === 0) {
    console.log("未能获取当前行政区域");
    return;
  }
  let resData = data[0].map(item => {
    const gcj = coordtransform.wgs84togcj02(item.lng, item.lat);
    // const bd = coordtransform.gcj02tobd09(gcj[0], gcj[1]);
    return { lng: gcj[0], lat: gcj[1] };
  });
  let ps = [];
  for (let i of resData) {
    ps.push(new AMap.Point(i.lng, i.lat));
  }
  //建立多边形覆盖物,Polygon第一参数是Point类，所以先在上面实例化Point类
  var ply = new AMap.Polygon(ps, {
    strokeWeight: 2,
    strokeColor: colors,
    fillColor: ""
  });

  // var allOverlay = map.getOverlays();
  // for (var i = 0; i < allOverlay.length - 1; i++) {
  //   map.removeOverlay(allOverlay[i]);
  // }
  map.addOverlay(ply); //添加覆盖物
}

function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

function getByteLen(str) {
  var len = 0;
  for (var i = 0; i < str.length; i++) {
    var ch = str.charCodeAt(i);
    if (ch >= 0 && ch <= 128) {
      len += 1;
    } else {
      len += 2;
    }
  }
  return len;
}

function hexToRgba(hex, opacity) {
  return (
    "rgba(" +
    parseInt("0x" + hex.slice(1, 3)) +
    "," +
    parseInt("0x" + hex.slice(3, 5)) +
    "," +
    parseInt("0x" + hex.slice(5, 7)) +
    "," +
    opacity +
    ")"
  );
}

// 保留两位小数，没有的后面补零
function toDecimal2(x) {
  var f = Math.round(x * 100) / 100;
  var s = f.toString();
  var rs = s.indexOf(".");
  if (rs < 0) {
    rs = s.length;
    s += ".";
  }
  while (s.length <= rs + 2) {
    s += "0";
  }
  return s;
}

// 定义区域筛选
function filterDataByRegion(data, polygons) {
  if (data && data.length > 0) {
    const polygonsL = polygons && polygons.length;
    if (polygonsL) {
      data = data.filter(item => {
        let inPolygons = false;
        // 标站坐标为百度坐标，polygon坐标为wgs84坐标，将标站坐标转为wgs84
        const gcj = coordtransform.bd09togcj02(item.lng, item.lat);
        const wgs84 = coordtransform.gcj02towgs84(gcj[0], gcj[1]);
        const point = [wgs84[0], wgs84[1]];
        // 判断是否在区域内
        for (let polygon of polygons) {
          inPolygons = inside(point, polygon);
          break;
        }
        return inPolygons;
      });
    }
    return data;
  } else {
    return [];
  }
}

//深拷贝
function deepCopy(source) {
  if (!isObject(source)) return source; //如果不是对象的话直接返回
  let target = Array.isArray(source) ? [] : {}; //数组兼容
  for (var k in source) {
    if (source.hasOwnProperty(k)) {
      if (typeof source[k] === "object") {
        target[k] = deepCopy(source[k]);
      } else {
        target[k] = source[k];
      }
    }
  }
  return target;
}

function isObject(obj) {
  return typeof obj === "object" && obj !== null;
}

// throttle 节流函数
function throttle(fn, wait) {
  var lastTime = 0;
  return function() {
    var nowTime = Date.now();
    if (nowTime - lastTime > wait) {
      fn.apply(this, arguments);
      lastTime = nowTime;
    }
  };
}

function getUuid() {
  // 获取uuid
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function strSlice(str, str_max_length) {
  if (!str) return str;
  if (str.length > str_max_length) {
    return str.slice(0, str_max_length) + "..";
  } else {
    return str;
  }
}

// 树结构数据扁平化
function flattenTree(tree) {
  return _.flatMapDeep(tree, node => {
    return [node, ...flattenTree(node.children)];
  });
}

// 树结构数据扁平化：只保留最深层的数据
function flattenArrayDeep(arr) {
  let result = [];

  arr.forEach(item => {
    if (item.children) {
      result = result.concat(flattenArrayDeep(item.children));
    } else {
      result.push(item);
    }
  });

  return result;
}

// 提取图片中经纬度
function extractLngLatFromImg(file) {
  if (!file) {
    return {};
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function(e) {
      const image = new Image();
      image.src = e.target.result;
      image.onload = function() {
        EXIF.getData(image, function() {
          // const imgAllInfo = EXIF.getAllTags(this);
          const imgLng = EXIF.getTag(this, "GPSLongitude");
          const imgLat = EXIF.getTag(this, "GPSLatitude");
          let lng = null,
            lat = null;
          if (imgLng && imgLat) {
            //计算出经纬度并保留6为小数
            lng = (imgLng[0] + imgLng[1] / 60 + imgLng[2] / 60 / 60).toFixed(6);
            lat = (imgLat[0] + imgLat[1] / 60 + imgLat[2] / 60 / 60).toFixed(6);
          }
          resolve({ lng: lng, lat: lat });
        });
      };
      image.onerror = function() {
        reject();
      };
    };
    reader.readAsDataURL(file);
  });
}

// 判断是否为数字
function isCheckNumber(value) {
  return /^-?\d+(\.\d+)?$/.test(value);
}

export {
  GetQueryString,
  getBoundary,
  drawBoundary,
  hexToRgba,
  toDecimal2,
  filterDataByRegion,
  deepCopy,
  drwaNovaecsBoundary,
  throttle,
  getUuid,
  strSlice,
  flattenTree,
  flattenArrayDeep,
  extractLngLatFromImg,
  isCheckNumber
};
